// import React from 'react';

export const Banner10DataSource = {
  wrapper: { className: 'banner1' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0' },
        // title: {
        //   className: 'banner1-title',
        //   children: 'home.corporateVisionTitle',
        // },
        // content: {
        //   className: 'banner1-content',
        //   children: 'home.corporateVisionContent',
        // },
        button: { className: 'banner1-button', children: 'Learn More' },
      },
      {
        name: 'elem1',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1' },
        // title: {
        //   className: 'banner1-title',
        //   children: 'home.corporateVisionTitle'
        // },
        // content: {
        //   className: 'banner1-content',
        //   children: 'home.corporateVisionContent'
        // },
      },
      // {
      //   name: 'elem2',
      //   BannerElement: { className: 'banner-user-elem' },
      //   textWrapper: { className: 'banner1-text-wrapper' },
      //   bg: { className: 'bg bg2' },
      //   title: {
      //     className: 'banner1-title',
      //     children: '@/assets/home/index.jpeg',
      //   },
      //   content: {
      //     className: 'banner1-content',
      //     children: '一个高效的以太网通讯解决方案',
      //   },
      //   button: { className: 'banner1-button', children: 'Learn More' },
      // },
    ],
  },
};
export const Content00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.1, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'home.productSolutions' },
      { name: 'sub-title', className: 'sub-title', children: 'PRODUCTION & SOLUTIONS' }
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        type: 'ota',
        active: true,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 'ota-icon.png',
              active: 'ota-active-icon.png'
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: 'home.ota',
            },
            {
              name: 'content',
              className: 'content0-block-content',
              title: 'home.ota',
              path: '/product/ota',
              children: 'home.otaContent',
              img: 'ota-content-img.png'
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        type: 'diagnosis',
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 'diag-icon.png',
              active: 'diag-active-icon.png'
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: 'home.diagnosis',
            },
            {
              name: 'content',
              className: 'content0-block-content',
              title: 'home.diagnosis',
              path: '/product/diagnosis',
              children: 'home.diagnosisContent',
              img: 'diag-content-img.png'
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        type: 'vehicle',
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 'soa-icon.png',
              active: 'soa-active-icon.png'
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: 'home.vehicle',
            },
            {
              name: 'content',
              className: 'content0-block-content',
              title: 'home.vehicle',
              path: '/product/basic',
              children: 'home.vehicleContent',
              img: 'soa-content-img.png'
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'content0-block',
        type: 'eLearn',
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 'eLearn-icon.png',
              active: 'eLearn-active-icon.png'
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: 'home.eLearn',
            },
            {
              name: 'content',
              className: 'content0-block-content',
              title: 'home.eLearn',
              path: '/product/eLearn',
              children: 'home.eLearnContent',
              img: 'eLearn-content-img.png'
            },
          ],
        },
      },
      // TODO 是否要增加工具链产品
      // {
      //   name: 'block4',
      //   className: 'content0-block',
      //   path: '/product/eLearn',
      //   children: {
      //     className: 'content0-block-item',
      //     children: [
      //       {
      //         name: 'image',
      //         className: 'content0-block-icon',
      //         children: 'ethernet.png',
      //       },
      //       {
      //         name: 'title',
      //         className: 'content0-block-title',
      //         children: 'home.toolChain',
      //       },
      //       {
      //         name: 'content',
      //         className: 'content0-block-content',
      //         children: ['home.toolChainContent1', 'home.toolChainContent2', 'home.toolChainContent3'],
      //       },
      //     ],
      //   },
      // },
    ],
  },
};

export const Content10DataSource = {
  wrapper: { className: 'home-page-wrapper content1-wrapper' },
  OverPack: { className: 'home-page content1', playScale: 0.3 },
  imgWrapper: { className: 'content1-img', md: 10, xs: 24 },
  img: {
    children: 'https://zos.alipayobjects.com/rmsportal/nLzbeGQLPyBJoli.png',
  },
  textWrapper: { className: 'content1-text', md: 12, xs: 24 },
  title: { className: 'content1-title', children: 'home.corporateVision' },
  content: {
    className: 'content1-content',
    children: 'home.corporateVisionContent',
  },
};

export const Content30DataSource = {
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'home.serviceTitle'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'PROFESSIONAL & SERVICES'
      },
      {
        name: 'content',
        className: 'content',
        children: 'home.serviceContent'
      }
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_01',
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle0' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent0',
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_02',
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle1' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent1',
          },
        },
      },
      {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_03',
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle2' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent2',
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_04',
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle3' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent3',
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_05',
          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle4' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent4',
          },
        },
      },
      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children: 'service_06',

          },
          textWrapper: { className: 'content3-text' },
          title: { className: 'content3-title', children: 'home.serviceItemTitle5' },
          content: {
            className: 'content3-content',
            children:
              'home.serviceItemContent5',
          },
        },
      },
    ],
  },
};
